import React, { Component } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import library from './Icons';
import { withRouter } from "react-router";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    Redirect
} from "react-router-dom";
import MenuAdmin from './MenuAdmin';

const styles = theme => ({
    selectable: {
        cursor: "pointer"
    },
    colorBlue: {
        color: "blue"
    },
    root: {
        display: 'flex',
        marginBottom: "10px"
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: "initial"
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: "100%",
        height: "auto"
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
});

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() { document.title = "Pupitres | Dashboard" }

    option = (icon, title, description, action, classes, key = 0) => {
        return (
            <Col key={key} xs={12} sm={12} md={6} lg={6} xl={6} >
                <Card className={`${classes.root} ${classes.selectable}`} onClick={action}>
                    <FontAwesomeIcon icon={icon} style={{ height: "100px", width: "100px", alignSelf: "center", padding: "0.5rem" }} />
                    <div className={classes.details}>
                        <CardContent className={classes.content}>
                            <Typography component="h5" variant="h5">
                                {title}
                            </Typography>
                            <Typography variant="subtitle1" color="textSecondary">
                                {description}
                            </Typography>
                        </CardContent>
                    </div>
                </Card>
            </Col>
        )
    }

    render() {
        const { classes, JWTToken, setMenu } = this.props;
        const { component } = this.state;

        return (
            <Container>
                <Switch>
                    <Route exact path={process.env.PUBLIC_URL + "/admin"}>
                        <Row className="justify-content-center">
                            {[
                                { icon: "user-shield", title: "Administrar Menú", "description": "Gestione la estructura de contenido del training.", action: () => { this.props.history.push(process.env.PUBLIC_URL + "/admin/menu") } },
                                { icon: "sign-out-alt", title: "Salir", "description": "Cierre la sesiòn del administrador.", action: this.props.logout },
                            ].map((entry, index) => this.option(entry.icon, entry.title, entry.description, entry.action, classes, index))}
                        </Row>
                    </Route>
                    <Route path={process.env.PUBLIC_URL + "/admin/menu"}>
                        <MenuAdmin setMenu={setMenu} />
                    </Route>
                </Switch>
            </Container>
        )
    }
}

export default withRouter((withStyles(styles)(Dashboard)));